<template>
  <td
    class="st-table-item__data-cell"
    :style="{ '--status-color': borderColor }"
    :class="{
      'st-table-item__data-cell--white-status': borderColor === '#FFFFFF',
    }"
  >
    <span class="st-table-item__data-cell__mobile-header">
      {{ header.name }}
    </span>
    <div
      v-if="data.component"
      :aria-label="data.ariaLabel"
      :role="data.clickEvent ? 'button' : undefined"
      :tabindex="data.clickEvent ? 0 : undefined"
      @click="data.clickEvent && handleItemClick($event)"
      @keydown.enter="data.clickEvent && handleItemClick($event)"
    >
      <component
        :is="data.component"
        v-bind="data.componentProps"
        v-on="componentListeners"
      />
    </div>
    <span v-else class="st-table-item__data-cell__span"> {{ data.value }}</span>
  </td>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  data: Object,
  header: Object,
  borderColor: String,
});

const emit = defineEmits(["component-event"]);

const componentListeners = computed(() => {
  const eventNames = Array.isArray(props.data.componentEmits)
    ? props.data.componentEmits
    : [props.data.componentEmits].filter(Boolean);

  return Object.fromEntries(
    eventNames.map((eventName) => [
      eventName,
      (...values) => emit("component-event", { eventName, values }),
    ]),
  );
});

const handleItemClick = (event) => {
  emit("component-event", {
    eventName: props.data.clickEvent,
    values: [],
  });
  event.stopPropagation();
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

.st-table-item__data-cell--white-status:first-child::before {
  box-shadow: inset 0 0 0 rem-calc(1) var(--disabled-color-secondary);
}

.st-table-item__data-cell {
  padding: rem-calc(18) rem-calc(10);
  display: flex;
  flex-direction: row;
  & > * {
    width: 50%;
  }

  padding-left: rem-calc(16);

  @include set-breakpoint {
    &:first-child {
      &::before {
        content: "";
        position: absolute;
        left: rem-calc(-8);
        top: rem-calc(-1);
        bottom: 0;
        width: rem-calc(8);
        background: var(--status-color);
        border-radius: rem-calc(4) 0 0 rem-calc(4);
      }
    }
  }
  &__span {
    color: var(--text-color-primary);
    font-size: rem-calc(16);
    word-wrap: break-word;
  }
  @include set-breakpoint {
    & > * {
      width: 100%;
    }
    display: table-cell;
    position: relative;
    padding: rem-calc(22);
  }
  &__mobile-header {
    display: table-header-group;
    font-weight: var(--font-weight-semi-bold);
    padding-right: rem-calc(10);
    word-wrap: break-word;
    @include set-breakpoint {
      display: none;
    }
  }
}
</style>
